import VerticalNavigation from './VerticalNavigation';

class VerticalNavigationOT extends VerticalNavigation {
  constructor(props) {
    super(props);  

    this.state = {
        redraw:false
    }
  }

  onClick(value, index){
    this.changeItem(value, index);

    this.props.data.OTModuleCallback(value, index);
  }

 
}

export default VerticalNavigationOT;